var options = {
  path: '/insight',
  title: ' 融媒数据雷达',
  icon: 'search',
  hideSub: true,
  children: (pre => [
    { path: `${pre}hot`, title: '全网热点', icon: 'dot-circle-o' },
    { path: `${pre}platform`, title: '平台热点', icon: 'dot-circle-o' },
    { path: `${pre}edu`, title: '教育热点', icon: 'dot-circle-o' },
    // { path: `${pre}edu/article`, title: '高校爆文', icon: 'dot-circle-o' },
    // { path: `http://yq.gsdata.cn`, title: '全网舆情', icon: 'dot-circle-o' },
    // { path: `http://hot.gsdata.cn`, title: '区域热点', icon: 'dot-circle-o' },
    // { path: `${pre}hotword`, title: '全网热词', icon: 'dot-circle-o' },
    // {
    //   path: `${pre}crawl`,
    //   title: '数据采集',
    //   icon: 'globe',
    //   children: [
    //     { path: `${pre}crawl/newmedia`, title: '新媒体采集', icon: 'dot-circle-o' }
    //   ]
    // },
    // { path: `${pre}alumnus`, title: '知名校友', icon: 'dot-circle-o' },
    // { path: `${pre}tomorrow`, title: '明日热点', icon: 'dot-circle-o' },
    // { path: `http://hot.gsdata.cn`, title: '行业热点', icon: 'dot-circle-o' },
    // { path: `http://yuqing.gsdata.cn/vindex/fullTextSearch`, title: '全媒体检索', icon: 'dot-circle-o' }

    // { path: `${pre}publish`, title: '发布审核', icon: 'location-arrow' },
    // { path: `${pre}publish/history`, title: '发布记录', icon: 'history' },
    // { path: `${pre}guest-article`, title: '投稿管理', icon: 'gears' },
    // {
    //   path: `${pre}insight`,
    //   title: '选题策划',
    //   icon: 'globe',
    //   children: [
    //     { path: `${pre}insight/hot`, title: '热点事件', icon: 'dot-circle-o' },
    //     { path: `${pre}insight/top`, title: '热点新闻', icon: 'dot-circle-o' },
    //     { path: `${pre}insight/monitor`, title: '热点方案', icon: 'dot-circle-o' }
    //   ]
    // },
    // { path: `${pre}bookmark`, title: '我的收藏', icon: 'bookmark-o' }
  ])('/insight/')
}

export default options
